// extracted by mini-css-extract-plugin
export default {"container":"style_container__I4ZHI","title":"style_title__hOFOd","divider":"style_divider__NrLaZ","children":"style_children__MGSjC","formFooter":"style_formFooter__qGOI0"};